import { JedeaiMetadataXSource } from '@sgdocs/client';
import { useRefListener, useWidget } from '../../widget/sgwt-configuration';
import { computeWidgetMapping } from './WidgetXSourceMapping';

export interface RichJsonSchemaWidgetProps {
  xSource: JedeaiMetadataXSource;
  onChange: (newValues: string) => void;
  value: string;
  placeholder?: string;
  readonly?: boolean;
}

export const RichJsonSchemaWidget = ({
  xSource,
  onChange,
  value,
  placeholder,
  readonly,
}: RichJsonSchemaWidgetProps): JSX.Element => {
  const { name, uri, render } = computeWidgetMapping(xSource);
  useWidget(uri ? `https://shared.fr.world.socgen${uri}` : '');
  const ref = useRefListener<any>(`${name}--selected`, (event: CustomEvent) => onChange(event.detail));
  return render(ref, onChange, value, placeholder, readonly);
};
